"use client";
import { useAppSelector } from "@/redux/store";
import { usePathname } from "next/navigation";

export default function PromoModal() {
  const isPWA = useAppSelector((state: any) => state.pwacheckReducer.isPWA);
  const pathname = usePathname();

  if (isPWA || pathname !== "/") return null;

  return (
    <div
      id="promoModal"
      className="modal fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 [@media(min-width:1025px)]:hidden px-4"
    >
      <div className="modal-content bg-[#f47920] p-6 rounded-xl text-center max-w-md w-full relative shadow-2xl border border-gray-300">
        <button
          className="close absolute top-2 right-2 text-gray-800 bg-white border border-gray-300 rounded-full w-6 h-6 flex items-center justify-center font-bold"
          onClick={() => {
            const modal = document.getElementById("promoModal");
            if (modal) {
              modal.style.display = "none";
            }
          }}
        >
          &times;
        </button>

        <div className="hero-row flex flex-row items-center gap-4 justify-center">
          <img src="/Logo.png" alt="Karma Logo" className="w-24 h-auto" />
          <h1 className="text-2xl font-extrabold text-[#003366] leading-snug tracking-wide uppercase text-left">
            Welcome to
            <br />
            our website!
          </h1>
        </div>

        <h2 className="mt-4 text-lg font-bold text-white">
          Download our new app
          <br />
          to receive updates on:
        </h2>

        <h3 className="text-[#003366] mt-4 font-bold leading-relaxed text-base">
          Free Ticket Giveaways
          <br />
          Game Day Deals
          <br />
          Discount Code Offers
          <br />
          Concert Price Drops
          <br />
          New Razz Launches
        </h3>

        <button
          className="bg-[#00b9f1] hover:bg-[#00a8de] text-white font-semibold py-2 px-6 rounded-full mt-4 transition duration-300"
          onClick={() => {
            const modal = document.getElementById("promoModal");
            if (modal) modal.style.display = "none";

            const script = document.createElement("script");
            script.type = "module";
            script.src = "/pwa-install-unminified.js";

            const pwaInstall = document.getElementById("pwa-install-element");

            if (pwaInstall) {
              pwaInstall.classList.remove("hidden");
              localStorage.setItem("pwa-installed", "true");
              const interval = setInterval(() => {
                if (typeof (pwaInstall as any).showDialog === "function") {
                  clearInterval(interval);
                  (pwaInstall as any).showDialog();
                }
              }, 100);
              setTimeout(() => clearInterval(interval), 100);
            }
          }}
        >
          Install App
        </button>

        <p className="text-gray-900 text-xs mt-4">
          Karma Tickets is a Toronto based company
        </p>
      </div>
    </div>
  );
}
